import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ObterUltimaEdicaoState } from '../../reducers/Jornal/obter-utlima-edicao.reducer';

export const selectObterUltimaEdicaoState = createFeatureSelector<ObterUltimaEdicaoState>('obterUltimaEdicao');

export const selectDadosObterUltimaEdicao = createSelector(
    selectObterUltimaEdicaoState,
    (state: ObterUltimaEdicaoState) => state.response
);

export const selectObterUltimaEdicao = createSelector(
  selectObterUltimaEdicaoState,
  (state: ObterUltimaEdicaoState) => state
);

export const selectErrosObterUltimaEdicao = createSelector(
    selectObterUltimaEdicaoState,
    (state: ObterUltimaEdicaoState) => state.error
);
